(function(){
'use strict';

// ==================== SPRINT FORMATS ====================
var SPRINT = [
  {id:'a6',name:'A6',w:100,h:140,std:2.00,exp:2.40,flash:2.80},
  {id:'a5',name:'A5',w:140,h:210,std:3.00,exp:3.60,flash:4.20},
  {id:'a4',name:'A4',w:210,h:280,std:4.20,exp:5.00,flash:5.80},
  {id:'a3',name:'A3',w:280,h:420,std:6.80,exp:9.00,flash:9.80},
  {id:'a2',name:'A2',w:420,h:570,std:12.75,exp:14.75,flash:17.85},
  {id:'1m',name:'1 m',w:570,h:1000,std:24.00,exp:28.80,flash:33.60},
  {id:'2m',name:'2 m',w:570,h:2000,std:41.60,exp:50.40,flash:58.24},
  {id:'4m',name:'4 m',w:570,h:4000,std:76.00,exp:91.20,flash:106.40}
];
function sprintPrice(f,s){return s==='express'?f.exp:s==='flash'?f.flash:f.std;}

// Paliers de remise Sprint par quantite de feuilles
var DISCOUNT_TIERS = [
  {min:100, mult:0.25, label:'-75%'},
  {min:50,  mult:0.40, label:'-60%'},
  {min:30,  mult:0.50, label:'-50%'},
  {min:20,  mult:0.50, label:'-50%'},
  {min:10,  mult:0.60, label:'-40%'},
  {min:5,   mult:0.70, label:'-30%'},
  {min:1,   mult:1.00, label:''}
];
var DISCOUNT_BREAKS = [5,10,20,30,50,100];
function getDiscount(qty){for(var i=0;i<DISCOUNT_TIERS.length;i++){if(qty>=DISCOUNT_TIERS[i].min)return DISCOUNT_TIERS[i];}return DISCOUNT_TIERS[DISCOUNT_TIERS.length-1];}
function sheetCost(unitPrice,qty){return unitPrice*qty*getDiscount(qty).mult;}

// ==================== CLOUD API (Cloudflare R2) ====================
var API_URL='https://nesting-dtf-api.reworkeddpt.workers.dev';
var API_PIN_VAL='1312';
function apiCall(method,path,body){
  var opts={method:method,headers:{'X-Pin':API_PIN_VAL,'Content-Type':'application/json'}};
  if(body)opts.body=JSON.stringify(body);
  return fetch(API_URL+path,opts).then(function(r){
    if(!r.ok)throw new Error('API '+r.status);
    return r.json();
  });
}
function dbPut(obj){return apiCall('POST','/save',obj);}
function dbAll(){return apiCall('GET','/list').then(function(d){return d.projects||[];});}
function dbGet(id){return apiCall('GET','/load/'+id);}
function dbDel(id){return apiCall('DELETE','/delete/'+id);}

// ==================== PROJECT MODEL ====================
var project = { name:'Nouveau projet', client:'', notes:'', planches:[], dbId:null };
var curPlanche = 0;
var imageCache = {};
var THUMB = 80;
var PIN = '1312';
var canvas, c2d, zoomLevel = 0.5, dragState = null;
var polyMode = false;
function usePolyMode(){ return polyMode && typeof NestEngine !== 'undefined'; }

function newPlanche(name) {
  return {
    id: Date.now() + Math.random(),
    name: name || 'Planche ' + (project.planches.length + 1),
    mode: 'sheet',
    formatId: 'a4',
    speed: 'standard',
    margins: {l:3,r:3,t:3,b:3},
    gaps: {x:3,y:3},
    dpi: 96,
    rollWidth: 570, rollUnit: 'mm', pricePerMeter: 0,
    motifs: [],
    placements: [],
    undoStack: [],
    redoStack: [],
    nextMotifId: 1,
    dirty: false
  };
}

function P() { return project.planches[curPlanche]; }
function fmt(p) { return SPRINT.find(function(f){return f.id===p.formatId;})||SPRINT[2]; }

// ==================== DOM ====================
var _q=function(id){return document.getElementById(id);};

// ==================== PIN ====================
var pinBuf='';
window.N={};
N.pin=function(n){
  if(pinBuf.length>=4)return;
  pinBuf+=n;
  var dots=document.querySelectorAll('.pin-dot');
  for(var i=0;i<4;i++)dots[i].classList.toggle('filled',i<pinBuf.length);
  if(pinBuf.length===4){
    if(pinBuf===PIN){setTimeout(function(){_q('scr-pin').classList.remove('active');_q('scr-app').classList.add('active');renderAll();},200);}
    else{dots.forEach(function(d){d.classList.add('error');});setTimeout(function(){dots.forEach(function(d){d.classList.remove('error','filled');});pinBuf='';},500);}
  }
};
N.pinBack=function(){if(!pinBuf.length)return;pinBuf=pinBuf.slice(0,-1);var d=document.querySelectorAll('.pin-dot');for(var i=0;i<4;i++)d[i].classList.toggle('filled',i<pinBuf.length);};
N.lock=function(){_q('scr-app').classList.remove('active');_q('scr-pin').classList.add('active');pinBuf='';document.querySelectorAll('.pin-dot').forEach(function(d){d.classList.remove('filled','error');});};

// ==================== PLANCHE TABS ====================
function renderPlancheTabs() {
  var bar = _q('planche-bar');
  bar.innerHTML = '';
  project.planches.forEach(function(pl, i) {
    var tab = document.createElement('div');
    tab.className = 'planche-tab' + (i === curPlanche ? ' on' : '');
    var f = fmt(pl);
    var label = pl.name;
    if (pl.mode === 'sheet') label += ' <span class="pt-format">' + f.name + '</span>';
    else label += ' <span class="pt-format">Rouleau</span>';
    tab.innerHTML = label;
    if (project.planches.length > 1) {
      tab.innerHTML += ' <span class="pt-close" data-del="' + i + '">&times;</span>';
    }
    tab.addEventListener('click', function(e) {
      if (e.target.dataset.del !== undefined) {
        var idx = parseInt(e.target.dataset.del);
        if (project.planches.length <= 1) return;
        project.planches.splice(idx, 1);
        if (curPlanche >= project.planches.length) curPlanche = project.planches.length - 1;
        renderAll();
        return;
      }
      saveToPlanche();
      curPlanche = i;
      loadFromPlanche();
      renderAll();
    });
    bar.appendChild(tab);
  });
  var addBtn = document.createElement('div');
  addBtn.className = 'planche-add';
  addBtn.textContent = '+';
  addBtn.title = 'Ajouter une planche';
  addBtn.onclick = function() {
    saveToPlanche();
    project.planches.push(newPlanche());
    curPlanche = project.planches.length - 1;
    loadFromPlanche();
    renderAll();
  };
  bar.appendChild(addBtn);
}

// ==================== SAVE/LOAD PLANCHE STATE ====================
function saveToPlanche() {
  var p = P(); if (!p) return;
  p.mode = document.querySelector('.mode-btn.active') ? document.querySelector('.mode-btn.active').dataset.mode : 'sheet';
  p.speed = _q('speed-select').value;
  p.margins = { l:parseFloat(_q('margin-left').value)||0, r:parseFloat(_q('margin-right').value)||0, t:parseFloat(_q('margin-top').value)||0, b:parseFloat(_q('margin-bottom').value)||0 };
  p.gaps = { x:parseFloat(_q('gap-x').value)||0, y:parseFloat(_q('gap-y').value)||0 };
  p.dpi = parseFloat(_q('dpi').value)||96;
  p.rollWidth = parseFloat(_q('roll-width').value)||570;
  p.rollUnit = _q('roll-unit').value;
  p.pricePerMeter = parseFloat(_q('price-per-meter').value)||0;
}

function loadFromPlanche() {
  var p = P(); if (!p) return;
  // Mode
  document.querySelectorAll('.mode-btn').forEach(function(b){b.classList.toggle('active',b.dataset.mode===p.mode);});
  _q('roll-params').style.display = p.mode==='roll'?'block':'none';
  _q('sheet-params').style.display = p.mode==='sheet'?'block':'none';
  // Speed & format
  _q('speed-select').value = p.speed;
  // Margins
  _q('margin-left').value=p.margins.l; _q('margin-right').value=p.margins.r;
  _q('margin-top').value=p.margins.t; _q('margin-bottom').value=p.margins.b;
  _q('gap-x').value=p.gaps.x; _q('gap-y').value=p.gaps.y;
  _q('dpi').value=p.dpi;
  _q('roll-width').value=p.rollWidth; _q('roll-unit').value=p.rollUnit;
  _q('price-per-meter').value=p.pricePerMeter;
  // Dirty
  _q('dirty-banner').classList.toggle('show', p.dirty && p.placements.length > 0);
  // Preload images
  p.motifs.forEach(function(m){ preloadImage(m); });
  renderFormats();
  renderMotifList();
}

N.setMode = function(mode) {
  var p = P();
  p.mode = mode;
  document.querySelectorAll('.mode-btn').forEach(function(b){b.classList.toggle('active',b.dataset.mode===mode);});
  _q('roll-params').style.display = mode==='roll'?'block':'none';
  _q('sheet-params').style.display = mode==='sheet'?'block':'none';
  p.placements = []; p.dirty = false;
  _q('dirty-banner').classList.remove('show');
  updateStats(); renderCanvas(); renderPlancheTabs();
};

// ==================== PARAMS ====================
function getParams() {
  var p = P(), f = fmt(p);
  if (p.mode === 'sheet') return { rollWidth:f.w, rollHeight:f.h, mL:p.margins.l, mR:p.margins.r, mT:p.margins.t, mB:p.margins.b, gX:p.gaps.x, gY:p.gaps.y, dpi:p.dpi, ppm:0, isSheet:true };
  var w = p.rollWidth; if (p.rollUnit==='cm') w*=10;
  return { rollWidth:w, rollHeight:99999, mL:p.margins.l, mR:p.margins.r, mT:p.margins.t, mB:p.margins.b, gX:p.gaps.x, gY:p.gaps.y, dpi:p.dpi, ppm:p.pricePerMeter, isSheet:false };
}

function pxToMm(px,dpi){return(px/dpi)*25.4;}
function getMotifMm(m){var p=P();var d=p.dpi||96;var w=m.overW!=null?m.overW:pxToMm(m.widthPx,d);var h=m.overH!=null?m.overH:pxToMm(m.heightPx,d);return{w:w,h:h};}

// ==================== DIRTY ====================
function markDirty(){var p=P();if(p.placements.length>0&&!p.dirty){p.dirty=true;_q('dirty-banner').classList.add('show');}}
function clearDirty(){var p=P();p.dirty=false;_q('dirty-banner').classList.remove('show');}

// ==================== THUMBNAILS ====================
function createThumb(dataUrl){return new Promise(function(r){var img=new Image();img.onload=function(){var c=document.createElement('canvas');var s=Math.min(THUMB/img.width,THUMB/img.height,1);c.width=Math.round(img.width*s);c.height=Math.round(img.height*s);c.getContext('2d').drawImage(img,0,0,c.width,c.height);r(c.toDataURL('image/jpeg',0.6));};img.onerror=function(){r(dataUrl);};img.src=dataUrl;});}
function preloadImage(m){return new Promise(function(r){if(imageCache[m.id])return r();var img=new Image();img.onload=function(){imageCache[m.id]=img;r();};img.onerror=r;img.src=m.dataUrl;});}

// ==================== FILE IMPORT ====================
function importImage(p, name, dataUrl) {
  return new Promise(function(resolve) {
    var img = new Image();
    img.onload = function() {
      createThumb(dataUrl).then(function(thumbUrl) {
        var motif = {id:p.nextMotifId++, name:name, dataUrl:dataUrl, thumbUrl:thumbUrl,
          widthPx:img.naturalWidth, heightPx:img.naturalHeight, overW:null, overH:null,
          qty:1, pivotable:true, polygon:null};
        if (typeof NestEngine !== 'undefined') motif.polygon = NestEngine.extractContour(img);
        p.motifs.push(motif); imageCache[motif.id] = img; resolve();
      });
    };
    img.onerror = resolve;
    img.src = dataUrl;
  });
}

function importPDF(p, file) {
  if (typeof pdfjsLib === 'undefined') { toast('pdf.js non charge', 'err'); return Promise.resolve(); }
  return new Promise(function(resolve) {
    var reader = new FileReader();
    reader.onload = function(ev) {
      var data = new Uint8Array(ev.target.result);
      pdfjsLib.getDocument({data:data}).promise.then(function(pdf) {
        var chain = Promise.resolve();
        var pages = pdf.numPages;
        for (var pg = 1; pg <= pages; pg++) {
          (function(pageNum) {
            chain = chain.then(function() {
              return pdf.getPage(pageNum).then(function(page) {
                var scale = 3;
                var vp = page.getViewport({scale:scale});
                var cv = document.createElement('canvas');
                cv.width = Math.round(vp.width); cv.height = Math.round(vp.height);
                var ctx = cv.getContext('2d');
                return page.render({canvasContext:ctx, viewport:vp}).promise.then(function() {
                  var dataUrl = cv.toDataURL('image/png');
                  var pageName = file.name.replace(/\.pdf$/i, '') + (pages > 1 ? ' (p' + pageNum + ')' : '') + '.png';
                  return importImage(p, pageName, dataUrl);
                });
              });
            });
          })(pg);
        }
        chain.then(resolve);
      }).catch(function(e) { toast('Erreur PDF: ' + e.message, 'err'); resolve(); });
    };
    reader.readAsArrayBuffer(file);
  });
}

function handleFiles(files){
  var p=P(),batch=[];
  for(var i=0;i<files.length;i++){(function(f){
    if(f.type === 'application/pdf' || f.name.match(/\.pdf$/i)) {
      batch.push(importPDF(p, f));
    } else if(f.type.match(/image\/(png|jpeg|svg\+xml)/)) {
      batch.push(new Promise(function(resolve){
        var reader=new FileReader();
        reader.onload=function(ev){ importImage(p, f.name, ev.target.result).then(resolve); };
        reader.readAsDataURL(f);
      }));
    }
  })(files[i]);}
  Promise.all(batch).then(function(){renderMotifList();markDirty();});
}

var $dz=_q('drop-zone'),$fi=_q('file-input');
$dz.addEventListener('dragover',function(e){e.preventDefault();$dz.classList.add('dragover');});
$dz.addEventListener('dragleave',function(){$dz.classList.remove('dragover');});
$dz.addEventListener('drop',function(e){e.preventDefault();$dz.classList.remove('dragover');handleFiles(e.dataTransfer.files);});
$fi.addEventListener('change',function(e){handleFiles(e.target.files);e.target.value='';});

// ==================== MOTIF LIST ====================
function renderMotifList(){
  var p=P(),ct=_q('motifs-container');ct.innerHTML='';
  p.motifs.forEach(function(m){
    var dims=getMotifMm(m);
    var div=document.createElement('div');div.className='motif-item';
    div.innerHTML='<img class="motif-thumb" src="'+m.thumbUrl+'" alt="">'+
      '<div class="motif-info"><div class="motif-name" title="'+m.name+'">'+m.name+'</div>'+
      '<div class="motif-dims-label">Dimensions</div>'+
      '<div class="motif-dims-row"><input class="fin" type="number" value="'+dims.w.toFixed(1)+'" min="1" step="0.5" data-action="dimw" title="Largeur"><span class="sep">&times;</span><input class="fin" type="number" value="'+dims.h.toFixed(1)+'" min="1" step="0.5" data-action="dimh" title="Hauteur"><span class="unit">mm</span></div>'+
      '<div class="motif-dims-label">Quantite & options</div>'+
      '<div class="motif-actions"><span class="btn-icon" data-action="qminus" title="-1">&minus;</span><input class="fin" type="number" value="'+m.qty+'" min="1" max="999" data-action="qty" title="Quantite"><span class="btn-icon" data-action="qplus" title="+1">+</span><span class="toggle-pivot '+(m.pivotable?'active':'')+'" data-action="pivot" title="Rotation auto">R</span><span class="btn-icon" data-action="dup" title="Dupliquer">\u229e</span><span class="btn-icon del" data-action="del" title="Supprimer">&times;</span></div>'+
      (m.polygon&&m.polygon.length>=3?'<div class="motif-poly-badge" title="Contour polygonal detecte">\u2b21 '+m.polygon.length+' pts</div>':'')+'</div>';
    div.addEventListener('change',function(e){var a=e.target.dataset.action;
      if(a==='qty'){m.qty=Math.max(1,parseInt(e.target.value)||1);markDirty();}
      if(a==='dimw'){var v=parseFloat(e.target.value);if(v>0){var ratio=m.heightPx/m.widthPx;m.overW=v;m.overH=parseFloat((v*ratio).toFixed(1));markDirty();renderMotifList();}}
      if(a==='dimh'){var v2=parseFloat(e.target.value);if(v2>0){var ratio2=m.widthPx/m.heightPx;m.overH=v2;m.overW=parseFloat((v2*ratio2).toFixed(1));markDirty();renderMotifList();}}
    });
    div.addEventListener('click',function(e){var a=e.target.dataset.action;
      if(a==='qminus'){m.qty=Math.max(1,m.qty-1);renderMotifList();markDirty();}
      else if(a==='qplus'){m.qty=Math.min(999,m.qty+1);renderMotifList();markDirty();}
      else if(a==='pivot'){m.pivotable=!m.pivotable;e.target.classList.toggle('active',m.pivotable);markDirty();}
      else if(a==='dup'){var d={};for(var k in m)d[k]=m[k];d.id=p.nextMotifId++;if(imageCache[m.id])imageCache[d.id]=imageCache[m.id];p.motifs.push(d);renderMotifList();markDirty();}
      else if(a==='del'){p.motifs=p.motifs.filter(function(x){return x.id!==m.id;});delete imageCache[m.id];p.placements=p.placements.filter(function(pl){return pl.motifId!==m.id;});renderMotifList();updateStats();renderCanvas();}
    });
    div.addEventListener('contextmenu',function(e){e.preventDefault();ctxTarget=m.id;_q('ctx-menu').style.left=e.clientX+'px';_q('ctx-menu').style.top=e.clientY+'px';_q('ctx-menu').style.display='block';});
    ct.appendChild(div);
  });
}

var ctxTarget=null;
document.addEventListener('click',function(){_q('ctx-menu').style.display='none';});
_q('ctx-duplicate').addEventListener('click',function(){if(!ctxTarget)return;var p=P(),m=p.motifs.find(function(x){return x.id===ctxTarget;});if(!m)return;var d={};for(var k in m)d[k]=m[k];d.id=p.nextMotifId++;if(imageCache[m.id])imageCache[d.id]=imageCache[m.id];p.motifs.push(d);renderMotifList();markDirty();});
_q('ctx-delete').addEventListener('click',function(){if(!ctxTarget)return;var p=P();p.motifs=p.motifs.filter(function(x){return x.id!==ctxTarget;});delete imageCache[ctxTarget];p.placements=p.placements.filter(function(pl){return pl.motifId!==ctxTarget;});renderMotifList();updateStats();renderCanvas();});

// ==================== FORMAT ====================
function renderFormats(){
  var p=P(),grid=_q('format-grid');grid.innerHTML='';
  SPRINT.forEach(function(f){
    var div=document.createElement('div');
    div.className='format-card'+(p.formatId===f.id?' active':'');
    var pr=sprintPrice(f,p.speed);
    div.innerHTML='<div class="fc-name">'+f.name+'</div><div class="fc-dim">'+(f.w/10)+' x '+(f.h/10)+' cm</div><div class="fc-price">'+pr.toFixed(2)+' \u20ac</div>';
    div.onclick=function(){p.formatId=f.id;renderFormats();markDirty();updateStats();renderCanvas();renderPlancheTabs();};
    grid.appendChild(div);
  });
}

// ==================== NESTING ====================
function runNesting(){
  var p=P(),par=getParams(),usableW=par.rollWidth-par.mL-par.mR,usableH=par.isSheet?(par.rollHeight-par.mT-par.mB):999999;
  if(usableW<=0){toast('Largeur invalide','err');return;}
  var items=[];
  p.motifs.forEach(function(m){var d=getMotifMm(m);for(var i=0;i<m.qty;i++)items.push({mid:m.id,w:d.w,h:d.h,piv:m.pivotable,area:d.w*d.h});});
  if(!items.length){toast('Aucun motif','err');return;}
  items.sort(function(a,b){var ma=Math.max(a.w,a.h),mb=Math.max(b.w,b.h);return Math.abs(mb-ma)>0.1?mb-ma:b.area-a.area;});
  var sky=[{x:0,y:0,w:usableW}],res=[];
  items.forEach(function(it){
    var oris=[{w:it.w,h:it.h,r:false}];
    if(it.piv&&Math.abs(it.w-it.h)>0.01)oris.push({w:it.h,h:it.w,r:true});
    var best=null;
    oris.forEach(function(o){if(o.w>usableW+0.01)return;
      for(var si=0;si<sky.length;si++){var sx=sky[si].x;if(sx+o.w>usableW+0.01)continue;
        var my=0,cx=sx;for(var j=si;j<sky.length&&cx<sx+o.w-0.001;j++){my=Math.max(my,sky[j].y);cx=sky[j].x+sky[j].w;}
        if(cx<sx+o.w-0.01)return;if(my+o.h>usableH+0.01)continue;
        var sc=my+o.h;if(!best||sc<best.sc||(Math.abs(sc-best.sc)<0.01&&sx<best.x))best={x:sx,y:my,w:o.w,h:o.h,r:o.r,sc:sc};
      }
    });
    if(best){res.push({motifId:it.mid,x:par.mL+best.x,y:par.mT+best.y,w:best.w,h:best.h,rotated:best.r});sky=updSky(sky,best.x,best.y+best.h+par.gY,best.w+par.gX,usableW);}
  });
  var placed=res.length,total=items.length;
  if(placed<total){
    var missing=total-placed;
    toast(placed+'/'+total+' places — '+missing+' motif'+(missing>1?'s':'')+' hors feuille !','err');
    // Show persistent warning
    var wb=_q('overflow-banner');
    if(wb){wb.textContent='\u26a0 '+missing+' motif'+(missing>1?'s ne rentrent':' ne rentre')+' pas sur cette feuille ('+placed+'/'+total+' places)';wb.classList.add('show');}
  } else {
    toast(placed+' motifs places','ok');
    var wb2=_q('overflow-banner');if(wb2)wb2.classList.remove('show');
  }
  pushUndo();p.placements=res;p.redoStack=[];clearDirty();updateStats();renderCanvas();
}

function updSky(sky,x,ny,rw,mw){var w=Math.min(rw,mw-x);if(w<=0)return sky;var x2=x+w,out=[];
  sky.forEach(function(s){var sl=s.x,sr=s.x+s.w;if(sr<=x+.001||sl>=x2-.001){out.push({x:s.x,y:s.y,w:s.w});}else{if(sl<x-.001)out.push({x:sl,y:s.y,w:x-sl});if(sr>x2+.001)out.push({x:x2,y:s.y,w:sr-x2});}});
  out.push({x:x,y:ny,w:w});out.sort(function(a,b){return a.x-b.x;});
  var m=[out[0]];for(var i=1;i<out.length;i++){var l=m[m.length-1];if(Math.abs(l.y-out[i].y)<.01&&Math.abs(l.x+l.w-out[i].x)<.01)l.w+=out[i].w;else m.push(out[i]);}return m;
}

// ==================== POLYGONAL NESTING ====================
function runNestingPoly(){
  var p=P(),par=getParams();
  if(!p.motifs.length){toast('Aucun motif','err');return;}
  var neItems=NestEngine.buildItems(p.motifs,p.dpi);
  if(!neItems.length){toast('Aucun motif','err');return;}

  var progEl=_q('nest-progress');
  if(progEl) progEl.style.display='flex';

  NestEngine.nestGA(neItems, par.rollWidth, par.isSheet?par.rollHeight:99999, {
    cellSize:1, gapX:par.gX, gapY:par.gY,
    margins:{l:par.mL,r:par.mR,t:par.mT,b:par.mB},
    isSheet:par.isSheet,
    onProgress:function(info){
      var t=_q('nest-progress-text'), b=_q('nest-progress-bar');
      if(t) t.textContent='Generation '+info.generation+'/'+info.totalGenerations+' — '+info.fill.toFixed(1)+'%';
      if(b) b.style.width=(info.generation/info.totalGenerations*100)+'%';
    }
  }).then(function(result){
    if(progEl) progEl.style.display='none';
    if(!result){toast('Erreur nesting','err');return;}
    pushUndo();
    p.placements=result.placements;
    p.redoStack=[];clearDirty();
    var placed=result.placed,total=result.total;
    if(placed<total){
      var miss=total-placed;
      toast(placed+'/'+total+' places — '+miss+' motif'+(miss>1?'s':'')+' hors feuille !','err');
      var wb=_q('overflow-banner');
      if(wb){wb.textContent='\u26a0 '+miss+' motif'+(miss>1?'s ne rentrent':' ne rentre')+' pas ('+placed+'/'+total+')';wb.classList.add('show');}
    } else {
      toast(placed+' motifs places ('+result.fill.toFixed(1)+'%)','ok');
      var wb2=_q('overflow-banner');if(wb2) wb2.classList.remove('show');
    }
    updateStats();renderCanvas();
  });
}

N.togglePoly=function(){
  polyMode=!polyMode;
  var btn=_q('poly-toggle');
  if(btn) btn.classList.toggle('active',polyMode);
  // Extract contours for motifs that don't have one yet
  if(polyMode&&typeof NestEngine!=='undefined'){
    var p=P();
    p.motifs.forEach(function(m){
      if(!m.polygon&&imageCache[m.id]) m.polygon=NestEngine.extractContour(imageCache[m.id]);
    });
    renderMotifList();
  }
};

// ==================== COST ENGINE v4 — WITH DISCOUNT TIERS ====================
function simNesting(items,W,H,gX,gY){
  if(W<=0||H<=0)return{placed:0,total:items.length,fill:0};
  var sky=[{x:0,y:0,w:W}],placed=0,ua=0;
  items.forEach(function(it){
    var oris=[{w:it.w,h:it.h}];if(it.piv&&Math.abs(it.w-it.h)>.01)oris.push({w:it.h,h:it.w});
    var best=null;
    oris.forEach(function(o){if(o.w>W+.01)return;for(var si=0;si<sky.length;si++){var sx=sky[si].x;if(sx+o.w>W+.01)continue;var my2=0,cx=sx;for(var j=si;j<sky.length&&cx<sx+o.w-.001;j++){my2=Math.max(my2,sky[j].y);cx=sky[j].x+sky[j].w;}if(cx<sx+o.w-.01)return;if(my2+o.h>H+.01)continue;var sc=my2+o.h;if(!best||sc<best.sc||(Math.abs(sc-best.sc)<.01&&sx<best.x))best={x:sx,y:my2,w:o.w,h:o.h,sc:sc};}});
    if(best){placed++;ua+=best.w*best.h;sky=updSky(sky,best.x,best.y+best.h+gY,best.w+gX,W);}
  });
  return{placed:placed,total:items.length,fill:W*H>0?ua/(W*H)*100:0};
}
function buildItems(p){var items=[];p.motifs.forEach(function(m){var d=getMotifMm(m);for(var i=0;i<m.qty;i++)items.push({w:d.w,h:d.h,piv:m.pivotable,area:d.w*d.h,mid:m.id});});items.sort(function(a,b){var ma=Math.max(a.w,a.h),mb=Math.max(b.w,b.h);return Math.abs(mb-ma)>.1?mb-ma:b.area-a.area;});return items;}
function usable(f,mg){return[{w:f.w-mg.l-mg.r,h:f.h-mg.t-mg.b},{w:f.h-mg.l-mg.r,h:f.w-mg.t-mg.b}];}

// Pack N items greedily across sheets. Returns array of {placed, fill} per sheet, or null.
function multiPack(items,f,mg,gX,gY){
  var u=usable(f,mg),rem=items.slice(),sheets=[],max=120;
  while(rem.length>0&&sheets.length<max){
    var r1=simNesting(rem,u[0].w,u[0].h,gX,gY);var r2=simNesting(rem,u[1].w,u[1].h,gX,gY);
    var b=r1.placed>=r2.placed?r1:r2;
    if(b.placed===0)return null;
    sheets.push({placed:b.placed,fill:b.fill});rem=rem.slice(b.placed);
  }
  if(rem.length>0)return null;
  return sheets;
}

// Candidate purchase quantities: min_required + all discount breakpoints + a few above min
function candidateQtys(minReq){
  var c={};c[minReq]=1;
  DISCOUNT_BREAKS.forEach(function(bp){if(bp>=minReq)c[bp]=1;});
  // Also test a few above min to catch edge cases
  for(var q=minReq;q<=Math.min(minReq+4,120);q++)c[q]=1;
  return Object.keys(c).map(Number).sort(function(a,b){return a-b;});
}

// ==================== FULL SOLVER ====================
function solveStrategies(){
  var p=P();if(!p.motifs.length)return null;
  var items=buildItems(p),qty=items.length;if(!qty)return null;
  var gX=p.gaps.x,gY=p.gaps.y,mg=p.margins,spd=p.speed;

  var solutions=[];

  SPRINT.forEach(function(f){
    // Step 1: How many items fit on ONE sheet of this format?
    var pack=multiPack(items,f,mg,gX,gY);
    if(!pack)return; // motifs too big for this format
    var minSheets=pack.length;
    var perSheetAvg=Math.ceil(qty/minSheets);
    // Capacity of first sheet (best case)
    var firstSheetCap=pack[0].placed;
    var unitPr=sprintPrice(f,spd);

    // Step 2: Test all candidate purchase quantities
    var cands=candidateQtys(minSheets);
    cands.forEach(function(buyQty){
      if(buyQty<minSheets)return;
      var disc=getDiscount(buyQty);
      var totalCost=unitPr*buyQty*disc.mult;
      var extraSheets=buyQty-minSheets;
      // Total capacity = actual items + extra sheets * avg capacity
      var extraCap=extraSheets*firstSheetCap;
      var totalCap=qty+extraCap;

      solutions.push({
        f:f,
        buyQty:buyQty,
        minSheets:minSheets,
        extraSheets:extraSheets,
        perSheet:pack,
        discount:disc,
        unitPrice:unitPr,
        discountedUnit:unitPr*disc.mult,
        totalCost:totalCost,
        cpm:totalCost/qty, // cost per design ORDERED
        cpmCap:totalCost/totalCap, // cost per design if you fill extras
        totalCap:totalCap,
        extraCap:extraCap,
        label:buyQty+'\u00d7 '+f.name+(disc.label?' ('+disc.label+')':'')
      });
    });
  });

  // Sort by total cost, then by cpm, then by buy qty (lower = less waste)
  solutions.sort(function(a,b){
    if(Math.abs(a.totalCost-b.totalCost)>0.01)return a.totalCost-b.totalCost;
    if(Math.abs(a.cpm-b.cpm)>0.001)return a.cpm-b.cpm;
    return a.buyQty-b.buyQty;
  });

  return{solutions:solutions,qty:qty};
}

// ==================== COST PANEL ====================
function updateCostPanel(){
  var cp=_q('cost-panel'),p=P(),par=getParams();
  if(!p.motifs.length){cp.innerHTML='<div class="cost-row"><span class="cost-label">Aucun motif</span></div>';return;}
  var html='',baseQty=0;p.motifs.forEach(function(m){baseQty+=m.qty;});
  var sl={standard:'48/72h',express:'24h',flash:'6h'}[p.speed]||'';

  // ---- ACCORDEON TARIFS ----
  html+='<details class="tarif-accordion"><summary class="sb-title" style="cursor:pointer;margin-bottom:0;list-style:none;display:flex;align-items:center;gap:6px"><span style="font-size:8px">\u25b6</span> Tarifs & paliers Sprint ('+sl+')</summary>';
  html+='<div style="margin-top:8px">';
  html+='<div style="font-size:9px;color:var(--aa);margin-bottom:3px">PALIERS DE REMISE (par nombre de feuilles)</div>';
  html+='<table class="price-table"><tr><th>Feuilles</th><th>Remise</th><th>Vous payez</th></tr>';
  DISCOUNT_TIERS.forEach(function(t){
    html+='<tr><td style="font-weight:600">\u2265 '+t.min+'</td><td>'+(t.label||'Plein tarif')+'</td><td>'+(t.mult*100).toFixed(0)+'% du prix</td></tr>';
  });
  html+='</table>';
  html+='<div style="font-size:9px;color:var(--aa);margin-top:8px;margin-bottom:3px">PRIX UNITAIRE PAR FORMAT</div>';
  html+='<table class="price-table"><tr><th>Format</th><th>Dim.</th><th>Prix</th></tr>';
  SPRINT.forEach(function(f){var pr=sprintPrice(f,p.speed);
    html+='<tr><td style="font-weight:600">'+f.name+'</td><td>'+(f.w/10)+'\u00d7'+(f.h/10)+' cm</td><td style="font-weight:600">'+pr.toFixed(2)+' \u20ac</td></tr>';
  });
  html+='</table></div></details>';

  // ---- PLANCHE ACTUELLE ----
  if(p.mode==='sheet'&&p.placements.length){
    var cf=fmt(p),cpr=sprintPrice(cf,p.speed),cua=0;p.placements.forEach(function(pl){cua+=pl.w*pl.h;});
    var placed=p.placements.length;
    html+='<div class="sb-title" style="margin-top:12px;margin-bottom:4px">Planche actuelle</div>';
    html+='<div class="cost-row"><span class="cost-label">'+cf.name+'</span><span class="cost-val">'+cpr.toFixed(2)+' \u20ac</span></div>';
    html+='<div class="cost-row"><span class="cost-label">Places</span><span class="cost-val">'+placed+' / '+baseQty+'</span></div>';
    html+='<div class="cost-row"><span class="cost-label">Remplissage</span><span class="cost-val">'+(cua/(cf.w*cf.h)*100).toFixed(1)+'%</span></div>';
    if(placed<baseQty){
      html+='<div style="padding:6px 8px;background:var(--red-bg);border-radius:6px;margin-top:6px;font-size:11px;color:var(--red);font-weight:600">\u26a0 '+(baseQty-placed)+' motif'+(baseQty-placed>1?'s ne rentrent':' ne rentre')+' pas sur cette feuille</div>';
    }
  } else if(p.placements.length){
    var tl=0;p.placements.forEach(function(pl){tl=Math.max(tl,pl.y+pl.h);});
    html+='<div class="sb-title" style="margin-top:12px">Rouleau</div>';
    html+='<div class="cost-row"><span class="cost-label">Longueur</span><span class="cost-val">'+tl.toFixed(1)+' mm</span></div>';
    html+='<div class="cost-row"><span class="cost-label">Cout</span><span class="cost-val">'+((tl/1000)*par.ppm).toFixed(2)+' \u20ac</span></div>';
  }

  // ---- STRATEGIES ----
  var result=solveStrategies();
  if(result&&result.solutions.length>0){
    var sols=result.solutions;
    var best=sols[0];

    html+='<div class="sb-title" style="margin-top:14px;margin-bottom:4px">Strategie optimale \u2014 '+baseQty+' motif'+(baseQty>1?'s':'')+'</div>';

    // BEST (lowest total cost)
    html+='<div style="padding:10px;background:var(--green-bg);border-radius:8px;margin-bottom:6px">';
    html+='<div style="font-size:14px;font-weight:700;color:var(--green)">\u2713 '+best.label+'</div>';
    html+='<div style="font-size:12px;font-weight:600;color:var(--green);margin-top:2px">'+best.totalCost.toFixed(2)+' \u20ac total</div>';
    html+='<div style="font-size:11px;color:var(--55);margin-top:4px">';
    html+=best.discountedUnit.toFixed(2)+' \u20ac/feuille';
    if(best.discount.label) html+=' <span style="color:var(--green);font-weight:600">'+best.discount.label+'</span>';
    html+='</div>';
    html+='<div style="font-size:11px;color:var(--55)">'+best.cpm.toFixed(2)+' \u20ac/motif</div>';
    // Explain if buying more than needed thanks to discount
    if(best.extraSheets>0&&best.discount.label){
      var costWithoutDiscount=best.minSheets*best.unitPrice;
      var savings=(costWithoutDiscount-best.totalCost).toFixed(2);
      html+='<div style="font-size:10px;color:var(--blue);margin-top:6px;padding:6px 8px;background:rgba(0,102,204,0.06);border-radius:6px">';
      html+='<div>\u2139 '+best.buyQty+' feuilles au lieu de '+best.minSheets+' necessaires : le palier '+best.discount.label+' rend le total moins cher</div>';
      html+='<div style="margin-top:3px">'+best.totalCost.toFixed(2)+' \u20ac vs '+costWithoutDiscount.toFixed(2)+' \u20ac sans remise (\u2212'+savings+' \u20ac)</div>';
      html+='<div style="margin-top:3px;font-weight:600;color:var(--green)">'+best.extraCap+' designs gratuits en bonus ('+best.extraSheets+' feuille'+(best.extraSheets>1?'s':'')+' supplementaire'+(best.extraSheets>1?'s':'')+')</div>';
      html+='</div>';
    }
    if(best.minSheets>1){
      html+='<div style="font-size:10px;color:var(--66);margin-top:4px">';
      best.perSheet.forEach(function(sh,i){html+='F'+(i+1)+': '+sh.placed+' motifs';if(i<best.perSheet.length-1)html+=' / ';});
      html+='</div>';
    }
    if(best.extraCap>0&&!(best.extraSheets>0&&best.discount.label)){
      html+='<div style="font-size:10px;color:var(--66);margin-top:2px">+'+best.extraCap+' emplacements bonus sur les feuilles supplementaires</div>';
    }
    html+='</div>';

    // ALTERNATIVES (deduplicated, top 8)
    var shown=0,altHtml='',seen={};
    seen[best.f.id+'_'+best.buyQty]=1;
    for(var ai=1;ai<sols.length&&shown<8;ai++){
      var s=sols[ai];
      var key=s.f.id+'_'+s.discount.min;
      if(seen[key])continue;seen[key]=1;
      var tag=s.discount.label?' <span style="color:var(--green);font-size:9px">'+s.discount.label+'</span>':'';
      altHtml+='<div class="cost-row"><span class="cost-label">'+s.label+tag+'</span><span class="cost-val">'+s.totalCost.toFixed(2)+' \u20ac <span class="pt-ppcm">('+s.cpm.toFixed(2)+'/m.)</span></span></div>';
      shown++;
    }
    if(shown>0){
      html+='<div style="font-size:9px;color:var(--aa);margin-bottom:3px;margin-top:4px">ALTERNATIVES</div>';
      html+=altHtml;
    }
  } else if(p.motifs.length){
    html+='<div style="padding:8px;background:var(--red-bg);border-radius:8px;margin-top:12px;font-size:11px;color:var(--red)">Aucun format Sprint ne peut contenir ces motifs</div>';
  }

  cp.innerHTML=html;
}

// ==================== STATS ====================
function updateStats(){
  var p=P(),par=getParams(),sL=_q('stat-length'),sF=_q('stat-fill'),sC=_q('stat-cost');
  if(!p.placements.length){sL.textContent='0 mm';sF.textContent='0%';sC.textContent='0.00 \u20ac';updateCostPanel();return;}
  var tl=0,ua=0;p.placements.forEach(function(pl){tl=Math.max(tl,pl.y+pl.h);ua+=pl.w*pl.h;});
  var ta,cost,f=fmt(p);
  if(par.isSheet){ta=f.w*f.h;cost=sprintPrice(f,p.speed);}else{ta=par.rollWidth*tl;cost=(tl/1000)*par.ppm;}
  sL.textContent=tl.toFixed(1)+' mm';sF.textContent=(ta>0?(ua/ta*100):0).toFixed(1)+'%';sC.textContent=cost.toFixed(2)+' \u20ac';
  updateCostPanel();
}

// ==================== CANVAS ====================
function renderCanvas(){
  if(!canvas)return;
  var p=P(),par=getParams(),sw=par.rollWidth,sh=par.isSheet?par.rollHeight:300;
  if(!par.isSheet&&p.placements.length>0)p.placements.forEach(function(pl){sh=Math.max(sh,pl.y+pl.h+60);});
  var cw=sw*zoomLevel,ch=sh*zoomLevel,dpr=window.devicePixelRatio||1;
  canvas.width=Math.ceil(cw*dpr);canvas.height=Math.ceil(ch*dpr);
  canvas.style.width=cw+'px';canvas.style.height=ch+'px';
  c2d.setTransform(dpr,0,0,dpr,0,0);var z=zoomLevel;
  c2d.fillStyle='#e8e8e8';c2d.fillRect(0,0,cw,ch);
  c2d.fillStyle='#fff';c2d.fillRect(par.mL*z,par.mT*z,(sw-par.mL-par.mR)*z,(sh-par.mT-par.mB)*z);
  c2d.fillStyle='rgba(255,200,200,.2)';
  if(par.mL>0)c2d.fillRect(0,0,par.mL*z,ch);if(par.mR>0)c2d.fillRect((sw-par.mR)*z,0,par.mR*z,ch);
  if(par.mT>0)c2d.fillRect(0,0,cw,par.mT*z);if(par.mB>0)c2d.fillRect(0,(sh-par.mB)*z,cw,par.mB*z);
  c2d.save();c2d.strokeStyle='#ccc';c2d.lineWidth=1;c2d.setLineDash([4,4]);c2d.beginPath();
  if(par.mL>0){c2d.moveTo(par.mL*z,0);c2d.lineTo(par.mL*z,ch);}
  if(par.mR>0){var rx=(sw-par.mR)*z;c2d.moveTo(rx,0);c2d.lineTo(rx,ch);}
  if(par.mT>0){c2d.moveTo(0,par.mT*z);c2d.lineTo(cw,par.mT*z);}
  if(par.mB>0){var by2=(sh-par.mB)*z;c2d.moveTo(0,by2);c2d.lineTo(cw,by2);}
  c2d.stroke();c2d.restore();
  if(par.isSheet){c2d.strokeStyle='#333';c2d.lineWidth=2;c2d.strokeRect(0,0,cw,ch);}

  p.placements.forEach(function(pl,idx){
    var px=pl.x*z,py=pl.y*z,pw=pl.w*z,ph=pl.h*z;
    var img=imageCache[pl.motifId];
    if(img){
      c2d.save();
      if(pl.rotation&&pl.rotation!==0){
        // Multi-angle rotation
        var mot=p.motifs.find(function(m){return m.id===pl.motifId;});
        var ow=mot?getMotifMm(mot).w*z:pw, oh=mot?getMotifMm(mot).h*z:ph;
        c2d.translate(px+pw/2,py+ph/2);c2d.rotate(pl.rotation*Math.PI/180);
        c2d.drawImage(img,-ow/2,-oh/2,ow,oh);
      } else if(pl.rotated){
        c2d.translate(px+pw,py);c2d.rotate(Math.PI/2);c2d.drawImage(img,0,0,ph,pw);
      } else {
        c2d.drawImage(img,px,py,pw,ph);
      }
      c2d.restore();
    } else {c2d.fillStyle='#f0f0f0';c2d.fillRect(px,py,pw,ph);}
    // Polygon outline or bounding box
    if(pl.polygon&&pl.polygon.length>=3){
      c2d.beginPath();c2d.moveTo(pl.polygon[0].x*z,pl.polygon[0].y*z);
      for(var pi=1;pi<pl.polygon.length;pi++) c2d.lineTo(pl.polygon[pi].x*z,pl.polygon[pi].y*z);
      c2d.closePath();
      c2d.strokeStyle=(dragState&&dragState.idx===idx)?'#0066cc':'rgba(0,180,60,0.6)';
      c2d.lineWidth=(dragState&&dragState.idx===idx)?2:1.5;c2d.stroke();
    } else {
      c2d.strokeStyle=(dragState&&dragState.idx===idx)?'#0066cc':'rgba(0,0,0,.2)';
      c2d.lineWidth=(dragState&&dragState.idx===idx)?2:1;c2d.strokeRect(px,py,pw,ph);
    }
    if(pw>35&&ph>18){var motif=p.motifs.find(function(m){return m.id===pl.motifId;});if(motif){var nm=motif.name.length>18?motif.name.slice(0,17)+'\u2026':motif.name;c2d.fillStyle='rgba(0,0,0,.5)';c2d.fillRect(px,py,Math.min(pw,130),22);c2d.fillStyle='#fff';c2d.font='9px Inter,sans-serif';c2d.fillText(nm,px+3,py+10);c2d.fillText(pl.w.toFixed(0)+'x'+pl.h.toFixed(0)+'mm'+(pl.rotated?' (R'+((pl.rotation||90))+'°)':''),px+3,py+19);}}
  });

  if(!par.isSheet&&p.placements.length>0){var tl=0;p.placements.forEach(function(pl){tl=Math.max(tl,pl.y+pl.h);});var ly=tl*z;c2d.save();c2d.strokeStyle='#c62828';c2d.lineWidth=1.5;c2d.setLineDash([8,4]);c2d.beginPath();c2d.moveTo(0,ly);c2d.lineTo(cw,ly);c2d.stroke();c2d.restore();c2d.fillStyle='#c62828';c2d.font='bold 10px Inter,sans-serif';c2d.fillText(tl.toFixed(1)+' mm',4,ly-5);}
  if(par.isSheet){var ff=fmt(p);c2d.fillStyle='rgba(0,0,0,.04)';c2d.font='bold '+Math.max(14,30*z)+'px Inter,sans-serif';c2d.fillText(ff.name,8*z,ch-8*z);}
}

// ==================== DRAG & PAN ====================
var panState = null; // {startX, startY, scrollX, scrollY}

function initCanvasEvents(){
  canvas.addEventListener('mousedown',function(e){
    var p=P(),r=canvas.getBoundingClientRect(),mx=(e.clientX-r.left)/zoomLevel,my=(e.clientY-r.top)/zoomLevel;
    // Check if clicking on a placement
    for(var i=p.placements.length-1;i>=0;i--){var pl=p.placements[i];if(mx>=pl.x&&mx<=pl.x+pl.w&&my>=pl.y&&my<=pl.y+pl.h){pushUndo();p.redoStack=[];dragState={idx:i,ox:mx-pl.x,oy:my-pl.y};canvas.style.cursor='grabbing';e.preventDefault();return;}}
    // No placement hit: start panning
    var wrap=_q('canvas-wrap');
    panState={startX:e.clientX,startY:e.clientY,scrollX:wrap.scrollLeft,scrollY:wrap.scrollTop};
    canvas.style.cursor='move';
    e.preventDefault();
  });

  canvas.addEventListener('mousemove',function(e){
    var p=P(),r=canvas.getBoundingClientRect(),mx=(e.clientX-r.left)/zoomLevel,my=(e.clientY-r.top)/zoomLevel;
    // Dragging a placement
    if(dragState){var pl=p.placements[dragState.idx],par=getParams();pl.x=Math.max(0,mx-dragState.ox);pl.y=Math.max(0,my-dragState.oy);if(par.isSheet){pl.x=Math.min(pl.x,par.rollWidth-pl.w);pl.y=Math.min(pl.y,par.rollHeight-pl.h);}renderCanvas();return;}
    // Panning the view
    if(panState){var wrap=_q('canvas-wrap');wrap.scrollLeft=panState.scrollX-(e.clientX-panState.startX);wrap.scrollTop=panState.scrollY-(e.clientY-panState.startY);return;}
    // Hover cursor
    var over=false;for(var i=p.placements.length-1;i>=0;i--){var pl2=p.placements[i];if(mx>=pl2.x&&mx<=pl2.x+pl2.w&&my>=pl2.y&&my<=pl2.y+pl2.h){over=true;break;}}
    canvas.style.cursor=over?'grab':'default';
  });

  canvas.addEventListener('mouseup',function(){
    if(dragState){dragState=null;canvas.style.cursor='default';updateStats();renderCanvas();}
    if(panState){panState=null;canvas.style.cursor='default';}
  });
  canvas.addEventListener('mouseleave',function(){
    if(dragState){dragState=null;canvas.style.cursor='default';updateStats();renderCanvas();}
    if(panState){panState=null;canvas.style.cursor='default';}
  });
}

// ==================== UNDO/REDO ====================
function pushUndo(){var p=P();p.undoStack.push(JSON.parse(JSON.stringify(p.placements)));if(p.undoStack.length>60)p.undoStack.shift();}
function undo(){var p=P();if(!p.undoStack.length)return;p.redoStack.push(JSON.parse(JSON.stringify(p.placements)));p.placements=p.undoStack.pop();updateStats();renderCanvas();}
function redo(){var p=P();if(!p.redoStack.length)return;p.undoStack.push(JSON.parse(JSON.stringify(p.placements)));p.placements=p.redoStack.pop();updateStats();renderCanvas();}
document.addEventListener('keydown',function(e){if((e.ctrlKey||e.metaKey)&&!e.altKey){if(e.key==='z'&&!e.shiftKey){e.preventDefault();undo();}else if((e.key==='z'&&e.shiftKey)||e.key==='y'){e.preventDefault();redo();}}});

// ==================== ZOOM ====================
_q('zoom-slider').addEventListener('input',function(){zoomLevel=parseFloat(this.value);_q('zoom-label').textContent=Math.round(zoomLevel*100)+'%';renderCanvas();});
_q('canvas-wrap').addEventListener('wheel',function(e){if(!e.ctrlKey&&!e.metaKey)return;e.preventDefault();zoomLevel=Math.min(3,Math.max(.1,zoomLevel+(e.deltaY>0?-.05:.05)));_q('zoom-slider').value=zoomLevel;_q('zoom-label').textContent=Math.round(zoomLevel*100)+'%';renderCanvas();},{passive:false});

// ==================== SESSION ====================
function exportSession(){
  saveToPlanche();
  var data={v:3,project:{name:_q('proj-name').value,client:_q('proj-client').value,notes:_q('proj-notes').value},planches:project.planches.map(function(p){
    return{name:p.name,mode:p.mode,formatId:p.formatId,speed:p.speed,margins:p.margins,gaps:p.gaps,dpi:p.dpi,rollWidth:p.rollWidth,rollUnit:p.rollUnit,pricePerMeter:p.pricePerMeter,
      motifs:p.motifs.map(function(m){return{id:m.id,name:m.name,dataUrl:m.dataUrl,widthPx:m.widthPx,heightPx:m.heightPx,overW:m.overW,overH:m.overH,qty:m.qty,pivotable:m.pivotable,polygon:m.polygon||null};}),
      placements:p.placements,nextMotifId:p.nextMotifId};
  }),curPlanche:curPlanche};
  var blob=new Blob([JSON.stringify(data)],{type:'application/json'});var a=document.createElement('a');a.href=URL.createObjectURL(blob);
  a.download='nesting-'+(_q('proj-name').value||'projet').replace(/[^a-z0-9]/gi,'-')+'-'+new Date().toISOString().slice(0,10)+'.json';a.click();URL.revokeObjectURL(a.href);
}

function importSession(file){
  file.text().then(function(text){
    var d;try{d=JSON.parse(text);}catch(e){toast('JSON invalide','err');return;}
    project.dbId = null;
    var data = d.data || d; // Support both DB record and raw export
    if (d.project) { data.name=d.project.name; data.client=d.project.client; data.notes=d.project.notes; }
    restoreProjectData(data).then(function(){ toast('Projet importe','ok'); });
  });
}

// ==================== RENDER PLANCHE TO CANVAS (for export) ====================
function renderPlancheToCanvas(planche, scale) {
  var f = fmt(planche);
  var sw = planche.mode==='sheet' ? f.w : (planche.rollUnit==='cm' ? planche.rollWidth*10 : planche.rollWidth);
  var sh;
  if (planche.mode==='sheet') { sh = f.h; }
  else { sh = 100; planche.placements.forEach(function(pl){sh=Math.max(sh,pl.y+pl.h);}); sh += 10; }

  var ec = document.createElement('canvas');
  ec.width = Math.ceil(sw * scale); ec.height = Math.ceil(sh * scale);
  var cx = ec.getContext('2d');
  cx.fillStyle = '#fff'; cx.fillRect(0, 0, ec.width, ec.height);

  planche.placements.forEach(function(pl) {
    var img = imageCache[pl.motifId];
    if (img) {
      cx.save();
      if (pl.rotated) { cx.translate(pl.x*scale+pl.w*scale, pl.y*scale); cx.rotate(Math.PI/2); cx.drawImage(img,0,0,pl.h*scale,pl.w*scale); }
      else cx.drawImage(img, pl.x*scale, pl.y*scale, pl.w*scale, pl.h*scale);
      cx.restore();
    }
    cx.strokeStyle = 'rgba(0,0,0,.15)'; cx.lineWidth = 1;
    cx.strokeRect(pl.x*scale, pl.y*scale, pl.w*scale, pl.h*scale);
  });
  return { canvas: ec, wMm: sw, hMm: sh };
}

// ==================== EXPORT PNG ====================
function exportPNG(){
  var p=P();if(!p.placements.length){toast('Rien a exporter','err');return;}
  var r = renderPlancheToCanvas(p, 3);
  var a=document.createElement('a');a.href=r.canvas.toDataURL('image/png');
  a.download='nesting-dtf-'+p.name.replace(/[^a-z0-9]/gi,'-')+'.png';a.click();
}

// ==================== EXPORT PDF (fixed) ====================
function exportPDF(){
  var hasContent = false;
  project.planches.forEach(function(pl){ if(pl.placements.length) hasContent=true; });
  if(!hasContent){toast('Rien a exporter','err');return;}
  if(typeof window.jspdf==='undefined'){toast('jsPDF non charge','err');return;}

  saveToPlanche();
  var jsPDF = window.jspdf.jsPDF;
  var doc = null;

  project.planches.forEach(function(pl, idx) {
    if (!pl.placements.length) return;
    var f = fmt(pl);
    var sw = pl.mode==='sheet' ? f.w : (pl.rollUnit==='cm' ? pl.rollWidth*10 : pl.rollWidth);
    var sh;
    if (pl.mode==='sheet') sh = f.h;
    else { sh = 100; pl.placements.forEach(function(p2){sh=Math.max(sh,p2.y+p2.h);}); sh += 10; }
    var pageH = sh + 60;

    if (!doc) {
      doc = new jsPDF({ orientation: sw > pageH ? 'l' : 'p', unit: 'mm', format: [sw, pageH] });
    } else {
      doc.addPage([sw, pageH], sw > pageH ? 'l' : 'p');
    }

    // Render planche to a temp canvas then add as image
    var r = renderPlancheToCanvas(pl, 2);
    var imgData = r.canvas.toDataURL('image/jpeg', 0.92);
    try {
      doc.addImage(imgData, 'JPEG', 0, 0, sw, sh);
    } catch(e) {
      // Fallback: draw rectangles
      pl.placements.forEach(function(p2) { doc.setDrawColor(180); doc.rect(p2.x, p2.y, p2.w, p2.h); });
    }

    // Summary
    var sy = sh + 6;
    doc.setFontSize(10); doc.setTextColor(0);
    doc.text(pl.name + (pl.mode==='sheet'?' - '+f.name:'') , 5, sy);
    doc.setFontSize(8); sy += 5;
    var ua = 0; pl.placements.forEach(function(p2){ua+=p2.w*p2.h;});
    var ta = sw * sh;
    var fill = ta > 0 ? (ua/ta*100).toFixed(1) : '0';
    doc.text('Remplissage : '+fill+'%', 5, sy); sy+=4;
    if (pl.mode==='sheet') {
      doc.text('Cout Sprint ('+pl.speed+') : '+sprintPrice(f,pl.speed).toFixed(2)+' EUR', 5, sy); sy+=4;
    }
    doc.text('Motifs :', 5, sy); sy+=4;
    pl.motifs.forEach(function(m) {
      var cnt = pl.placements.filter(function(p2){return p2.motifId===m.id;}).length;
      if (cnt > 0) { var dims = {w: m.overW || pxToMm(m.widthPx,pl.dpi), h: m.overH || pxToMm(m.heightPx,pl.dpi)};
        doc.text('  - '+m.name+' : '+cnt+'x ('+dims.w.toFixed(1)+' x '+dims.h.toFixed(1)+' mm)', 5, sy); sy+=4; }
    });
  });

  // First page header with project info
  if (doc) {
    doc.setPage(1);
    var projName = _q('proj-name').value || 'Projet';
    doc.setFontSize(6); doc.setTextColor(150);
    doc.text('Projet : '+projName+' | Client : '+(_q('proj-client').value||'-')+' | '+new Date().toLocaleDateString('fr-FR'), 5, doc.internal.pageSize.getHeight()-3);
    doc.save('nesting-'+projName.replace(/[^a-z0-9]/gi,'-')+'.pdf');
  }
}

// ==================== TOAST ====================
function toast(msg,type){var c=_q('toastContainer'),t=document.createElement('div');t.className='toast toast-'+(type||'ok');t.textContent=msg;c.appendChild(t);setTimeout(function(){t.remove();},3000);}

// ==================== PROJECT SAVE TO DB ====================
function buildProjectData() {
  saveToPlanche();
  return {
    name: _q('proj-name').value || 'Sans titre',
    client: _q('proj-client').value || '',
    notes: _q('proj-notes').value || '',
    planches: project.planches.map(function(p) {
      return { name:p.name, mode:p.mode, formatId:p.formatId, speed:p.speed, margins:p.margins, gaps:p.gaps, dpi:p.dpi,
        rollWidth:p.rollWidth, rollUnit:p.rollUnit, pricePerMeter:p.pricePerMeter,
        motifs:p.motifs.map(function(m){ return {id:m.id,name:m.name,dataUrl:m.dataUrl,widthPx:m.widthPx,heightPx:m.heightPx,overW:m.overW,overH:m.overH,qty:m.qty,pivotable:m.pivotable,polygon:m.polygon||null}; }),
        placements:p.placements, nextMotifId:p.nextMotifId };
    }),
    curPlanche: curPlanche
  };
}

function saveProjectToDB() {
  var data = buildProjectData();
  var id = project.dbId || ('proj_' + Date.now());
  data.id = id;
  project.dbId = id;
  return dbPut(data).then(function(r) {
    if(r&&r.id) project.dbId = r.id;
    toast('Projet sauvegarde (cloud)', 'ok');
    refreshUsage();
  }).catch(function(e) {
    toast('Erreur sauvegarde: ' + e.message, 'err');
  });
}

function loadProjectFromDB(id) {
  return dbGet(id).then(function(data) {
    if (!data||data.error) { toast('Projet introuvable', 'err'); return; }
    project.dbId = id;
    return restoreProjectData(data);
  });
}

function restoreProjectData(d) {
  for (var k in imageCache) delete imageCache[k];
  _q('proj-name').value = d.name || '';
  _q('proj-client').value = d.client || '';
  _q('proj-notes').value = d.notes || '';
  project.planches = [];
  var chain = Promise.resolve();
  (d.planches || []).forEach(function(sp) {
    var pl = newPlanche(sp.name);
    pl.mode=sp.mode; pl.formatId=sp.formatId; pl.speed=sp.speed; pl.margins=sp.margins; pl.gaps=sp.gaps; pl.dpi=sp.dpi;
    pl.rollWidth=sp.rollWidth; pl.rollUnit=sp.rollUnit; pl.pricePerMeter=sp.pricePerMeter;
    pl.placements=sp.placements||[]; pl.nextMotifId=sp.nextMotifId||1; pl.motifs=[];
    (sp.motifs||[]).forEach(function(sm) {
      chain = chain.then(function() {
        return createThumb(sm.dataUrl).then(function(th) {
          var m = {id:sm.id,name:sm.name,dataUrl:sm.dataUrl,thumbUrl:th,widthPx:sm.widthPx,heightPx:sm.heightPx,overW:sm.overW||null,overH:sm.overH||null,qty:sm.qty,pivotable:sm.pivotable,polygon:sm.polygon||null};
          pl.motifs.push(m); return preloadImage(m).then(function(){
            if(!m.polygon&&typeof NestEngine!=='undefined'&&imageCache[m.id]) m.polygon=NestEngine.extractContour(imageCache[m.id]);
          });
        });
      });
    });
    project.planches.push(pl);
  });
  return chain.then(function() {
    if (!project.planches.length) project.planches.push(newPlanche());
    curPlanche = Math.min(d.curPlanche||0, project.planches.length-1);
    loadFromPlanche(); renderAll();
  });
}

function deleteProjectFromDB(id) {
  return dbDel(id).then(function() {
    toast('Projet supprime', 'ok');
    if (project.dbId === id) project.dbId = null;
  });
}

function startNewProject() {
  for (var k in imageCache) delete imageCache[k];
  project = { name:'Nouveau projet', client:'', notes:'', planches:[], dbId:null };
  project.planches.push(newPlanche());
  curPlanche = 0;
  _q('proj-name').value = 'Nouveau projet';
  _q('proj-client').value = '';
  _q('proj-notes').value = '';
  loadFromPlanche();
  renderAll();
}

// ==================== PROJECTS OVERLAY ====================
// ==================== R2 USAGE INDICATOR ====================
function refreshUsage() {
  apiCall('GET','/list').then(function(resp) {
    var u = resp.usage;
    if (!u) return;
    var el = _q('r2-usage');
    if (!el) return;
    var pct = u.percent || 0;
    var color = pct >= 95 ? 'var(--red)' : pct >= 80 ? 'var(--orange)' : 'var(--green)';
    el.className = 'r2-usage' + (pct >= 95 ? ' critical' : pct >= 80 ? ' warn' : '');
    el.innerHTML = '<div class="r2-bar"><div class="r2-fill" style="width:' + Math.min(pct, 100) + '%;background:' + color + '"></div></div>' +
      '<span>' + u.megabytes + ' Mo / ' + u.limitGb + ' Go</span>';
    el.title = 'Stockage cloud R2 : ' + pct + '% utilise (' + u.count + ' projets)';
  }).catch(function() {});
}

function openProjectsPanel() {
  _q('proj-overlay').classList.add('open');
  renderProjectList();
}

function closeProjectsPanel() {
  _q('proj-overlay').classList.remove('open');
}

function renderProjectList() {
  var list = _q('proj-list');
  list.innerHTML = '<div style="text-align:center;padding:20px;color:var(--aa)">Chargement...</div>';
  apiCall('GET','/list').then(function(resp) {
    var records = resp.projects || [];
    var usage = resp.usage;

    // Usage banner
    var usageHtml = '';
    if (usage) {
      var pct = usage.percent || 0;
      var barColor = pct >= 95 ? 'var(--red)' : pct >= 80 ? 'var(--orange)' : 'var(--green)';
      usageHtml += '<div style="padding:10px 14px;border-bottom:1px solid var(--ee);font-size:11px">';
      usageHtml += '<div style="display:flex;justify-content:space-between;margin-bottom:4px"><span style="color:var(--66)">Stockage R2</span><span style="font-weight:600">' + usage.megabytes + ' Mo / ' + usage.limitGb + ' Go (' + pct + '%)</span></div>';
      usageHtml += '<div style="height:6px;background:var(--ee);border-radius:3px;overflow:hidden"><div style="height:100%;width:' + Math.min(pct, 100) + '%;background:' + barColor + ';border-radius:3px"></div></div>';
      if (usage.warning) {
        usageHtml += '<div style="margin-top:6px;padding:6px 8px;border-radius:6px;font-weight:600;' + (usage.critical ? 'background:var(--red-bg);color:var(--red)' : 'background:var(--orange-bg);color:var(--orange)') + '">';
        usageHtml += usage.critical ? '\u26a0 Stockage critique ! Supprimez des anciens projets ou passez au forfait payant.' : '\u26a0 Stockage a ' + pct + '% — pensez a faire du menage dans les anciens projets.';
        usageHtml += '</div>';
      }
      usageHtml += '<div style="margin-top:4px;color:var(--aa);font-size:10px">' + usage.count + ' projet' + (usage.count > 1 ? 's' : '') + ' stocke' + (usage.count > 1 ? 's' : '') + '</div>';
      usageHtml += '</div>';
    }

    if (!records.length) {
      list.innerHTML = usageHtml + '<div class="proj-empty">Aucun projet sauvegarde.<br>Cliquez sur "Sauvegarder" pour enregistrer votre premier projet.</div>';
      return;
    }
    list.innerHTML = usageHtml;
    records.forEach(function(rec) {
      var card = document.createElement('div');
      card.className = 'proj-card';
      var dateStr = '';
      try { var d = new Date(rec.modified); dateStr = d.toLocaleDateString('fr-FR') + ' ' + d.toLocaleTimeString('fr-FR',{hour:'2-digit',minute:'2-digit'}); } catch(e){}
      var isCurrent = project.dbId === rec.id;
      var pc = parseInt(rec.plancheCount)||0;
      var mc = parseInt(rec.motifCount)||0;
      card.innerHTML =
        '<div class="proj-card-info">' +
          '<div class="proj-card-name">' + (isCurrent ? '<span class="proj-saved-dot"></span>' : '') + (rec.name||'Sans titre') + '</div>' +
          '<div class="proj-card-meta">' +
            (rec.client ? '<span>' + rec.client + '</span>' : '') +
            '<span>' + (pc||1) + ' planche' + (pc>1?'s':'') + '</span>' +
            '<span>' + mc + ' motif' + (mc>1?'s':'') + '</span>' +
            '<span>' + dateStr + '</span>' +
            '<span style="color:var(--aa)">' + (rec.size>1024?(rec.size/1024).toFixed(0)+' Ko':rec.size+' o') + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="proj-card-actions">' +
          '<span class="btn-icon" data-act="open" title="Ouvrir">&#x2197;</span>' +
          '<span class="btn-icon" data-act="dup" title="Dupliquer">+</span>' +
          '<span class="btn-icon del" data-act="del" title="Supprimer">&times;</span>' +
        '</div>';

      card.addEventListener('click', function(e) {
        var act = e.target.dataset.act;
        if (act === 'del') {
          if (confirm('Supprimer "' + (rec.name||'Sans titre') + '" ?')) {
            deleteProjectFromDB(rec.id).then(renderProjectList);
          }
          return;
        }
        if (act === 'dup') {
          dbGet(rec.id).then(function(r) {
            if (!r||r.error) return;
            var copy = JSON.parse(JSON.stringify(r));
            copy.id = 'proj_' + Date.now();
            copy.name = (copy.name||'') + ' (copie)';
            dbPut(copy).then(function() { toast('Projet duplique','ok'); renderProjectList(); });
          });
          return;
        }
        // Default: open
        closeProjectsPanel();
        loadProjectFromDB(rec.id).then(function() { toast('Projet charge (cloud)','ok'); });
      });
      list.appendChild(card);
    });
  }).catch(function(e) {
    list.innerHTML = '<div class="proj-empty">Erreur connexion : ' + e.message + '</div>';
  });
}

// ==================== LISTENERS ====================
_q('dpi').addEventListener('change',function(){saveToPlanche();renderMotifList();markDirty();});
['margin-left','margin-right','margin-top','margin-bottom','gap-x','gap-y','roll-width','roll-unit','price-per-meter'].forEach(function(id){
  var el=_q(id);if(el)el.addEventListener('change',function(){saveToPlanche();updateStats();renderCanvas();markDirty();});
});
_q('speed-select').addEventListener('change',function(){var p=P();p.speed=this.value;renderFormats();updateStats();renderPlancheTabs();});
_q('btn-reset-margins').addEventListener('click',function(){
  var p=P();
  p.margins={l:3,r:3,t:3,b:3};p.gaps={x:3,y:3};p.dpi=96;
  _q('margin-left').value=3;_q('margin-right').value=3;_q('margin-top').value=3;_q('margin-bottom').value=3;
  _q('gap-x').value=3;_q('gap-y').value=3;_q('dpi').value=96;
  markDirty();updateStats();renderCanvas();toast('Marges reinitialises','ok');
});
_q('btn-nest').addEventListener('click',function(){usePolyMode()?runNestingPoly():runNesting();});
_q('btn-renest').addEventListener('click',function(){usePolyMode()?runNestingPoly():runNesting();});
_q('btn-undo').addEventListener('click',undo);
_q('btn-redo').addEventListener('click',redo);
_q('btn-export-png').addEventListener('click',exportPNG);
_q('btn-export-pdf').addEventListener('click',exportPDF);
_q('btn-export-session').addEventListener('click',exportSession);
_q('btn-save-proj').addEventListener('click',saveProjectToDB);
_q('btn-open-history').addEventListener('click',openProjectsPanel);
_q('proj-close').addEventListener('click',closeProjectsPanel);
_q('proj-overlay').addEventListener('click',function(e){if(e.target===_q('proj-overlay'))closeProjectsPanel();});
_q('btn-new-proj').addEventListener('click',function(){closeProjectsPanel();startNewProject();toast('Nouveau projet','ok');});
_q('btn-import-proj').addEventListener('click',function(){_q('import-session-input').click();});
_q('import-session-input').addEventListener('change',function(e){if(e.target.files[0]){closeProjectsPanel();importSession(e.target.files[0]);}e.target.value='';});

// ==================== RENDER ALL ====================
function renderAll(){renderPlancheTabs();renderFormats();renderMotifList();updateStats();renderCanvas();}

// ==================== INIT ====================
canvas=_q('nest-canvas');c2d=canvas.getContext('2d');
project.planches.push(newPlanche());
loadFromPlanche();
initCanvasEvents();
renderAll();
refreshUsage();

})();
